import { DatePicker } from "antd";

const InputDate = ({
  placeholder = "Wybierz datę",
  format = "DD-MM-YYYY",
  getPopupContainer,
  ...rest
}) => (
  <DatePicker
    inputReadOnly
    picker="date"
    format={format}
    style={{ width: "100%" }}
    placeholder={placeholder}
    getPopupContainer={getPopupContainer}
    {...rest}
  />
);

export default InputDate;
